<template>
    <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow"
            >mdi-reload</v-icon
          >
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox
            class="no-display"
            v-model="registration_no"
            @change="checkHistory"
            :loading="comp_load"
            rounded
            :items="stud_list"
            label="Select Student"
            item-text="name"
            outlined
            dense
            prepend-icon="mdi-account-child-circle"
          ></v-combobox>
        </v-col>
      </v-row>
      <div v-if="registration_no != null">
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table
                  :headers="headers_1"
                  :items="ay_record"
                  class="elevation-1 mytable"
                  dense
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table
                  :headers="headers_2"
                  :items="ay_record_div"
                  dense
                  class="elevation-1 mytable"
                >
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group
            v-model="fetch_gen_toggle"
            mandatory
            row
            class="radiobtn"
          >
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50"
              >Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
    </v-card>
    <div v-if="registration_no != null">
      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <v-row justify="center" class="mt-3">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="last_date_of_school"
                @blur="date = parseDate(last_date_of_school)"
                v-on="on"
                hint="Last Date of Leaving"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="gen_date"
                @blur="date = parseDate(gen_date)"
                v-on="on"
                hint="Generation Date"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="application_date"
                @blur="date = parseDate(application_date)"
                v-on="on"
                hint="Date Of Application"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_of_application"
              no-title
              @input="menu4 = false"
              @change="setToText()"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="issue_date"
                @blur="date = parseDate(issue_date)"
                v-on="on"
                hint="Date Of Issue"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              label="Issue Date"
              v-model="date_of_issue"
              no-title
              @input="menu3 = false"
              @change="setToText2()"
            ></v-date-picker>
          </v-menu>
        </v-row>
        <!-- Date ends -->
        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="progress"
              rounded
              :items="dvt_prog"
              label="Select Progress"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="conduct"
              rounded
              :items="dvt_conduct"
              label="Select Conduct"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="remark"
              rounded
              :items="dvt_remark"
              label="Select Remark"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="reason"
              rounded
              :items="dvt_reason"
              label="Select Reason"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-checkbox
            color="#0f2027"
            v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"
          ></v-checkbox>
        </v-row>
        <v-row justify="center">
          <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
        </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <br />
      </template>
      <!-- lc format starts -->
         <div id="document1" class="printdiv main" v-if="lc_data != null">
        <v-row>
          <v-col cols="3" sm="3" md="3">
            <center>
                      <img
                        :src="org_basic_data.school_logo"
                        alt="school_logo"
                        height="120px"
                        width="170px"
                      />
                    </center>
          </v-col>
          <v-col cols="6" sm="6" md="6" align="center">
            <span>{{ org_basic_data.trust_name }}</span>
            <h1 style="font-size: 35px; text-transform: uppercase;">{{ org_basic_data.school_name }}</h1>
          </v-col>
          <v-col cols="3" sm="3" md="3">

          </v-col>
        </v-row>
        <hr style="border: 0; height: 1px; background-color: #EC407A;">
        <v-row style="font-size: small; color: navy; background-color: #FFFDE7">
          <v-col class="pl-5 pt-2 pb-2" cols="3" sm="3" md="3">
            <span> S.S.C Code - 12.04.43, </span><br>
            <span> H.S.C. Code - J-12.04.010 </span>
          </v-col>
          <v-col cols="5" sm="5" md="5"></v-col>
          <v-col class="pt-2 pb-2" cols="4" sm="4" md="4">
            <span>Society's Ph.No. (02423) 222862, 223362, 223947 </span><br>
            <span>Fax No. O2423-222682 </span>
          </v-col>
        </v-row>
        <hr style="border: 0; height: 1px; background-color: #EC407A;">
        <div class="ssc-line-height" style="padding: 5px; color: navy;">
        <span style="font-weight: bold; ">Name of the Institute - </span> <span style="color: #EC407A; font-weight: bold;">{{ org_basic_data.trust_name }}</span> <br>
        <span style="font-weight: bold; ">Name of the School -</span> <span style="color: #EC407A; font-weight: bold;"> {{ org_basic_data.school_name }}</span><br>
        <div>Address - {{ org_basic_data.address }}, Pin Code- {{org_basic_data.pin}}</div>
        <span>Phone No - {{ org_basic_data.phone }}, Email - {{ org_basic_data.email }}</span>
        <v-row >
          <v-col class="pt-0 pb-0" cols="9" sm="9" md="9">School Reg. No. - इसैशा/१०२०००/नसैशा/१५ क, शिक्षण संचालनालय, महाराष्ट्र राज्य, पुणे - १, दिनांक १/८/२०००</v-col>
          <v-col class="pt-0 pb-0 pr-10" cols="3" sm="3" md="3" align="left"> Medium - English</v-col>
        </v-row>
        <v-row >
          <v-col class="pt-0 pb-0" cols="9" sm="9" md="9">UDISE NO - {{ lc_data.udise_no }}</v-col>
          <v-col class="pt-0 pb-0 pr-10" cols="3" sm="3" md="3" align="left"> Board - Pune </v-col>
        </v-row>
        <v-row >
          <v-col class="pt-0 pb-0" cols="9" sm="9" md="9">Sr.No. - {{lc_data.certificate_no}}</v-col>
          <v-col class="pt-0 pb-0 pr-10" cols="3" sm="3" md="3" align="left"> Gen.Reg.No - {{ lc_data.gr_number }}</v-col>
        </v-row>
        </div>
        <hr style="border: 0; border-top: 1px dashed #EC407A;">
        <center><h1 class="gradient-heading">SCHOOL LEAVING CERTIFICATE</h1></center>
        <div class="row ssc-matter" style="color: navy;">
          <v-col cols="7" sm="7" md="7">Student I.D. <span class="bottom-line" style="width: 491px">{{ lc_data.saral_id }}</span></v-col>
          <v-col cols="5" sm="5" md="5">UID (Aadhar Card No) - <span class="bottom-line" style="width: 236px">{{ lc_data.aadhar_no }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Student's First Name - <span class="bottom-line" style="width: 158px">{{ lc_data.first_name }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Father's Name - <span class="bottom-line" style="width: 204px">{{ lc_data.middle_name }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Surname - <span class="bottom-line" style="width: 240px">{{ lc_data.last_name }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Mother's Name  - <span class="bottom-line" style="width: 199px">{{ lc_data.mother_first_name }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Nationality - <span class="bottom-line" style="width: 229px">{{ lc_data.nationality }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Mother Tongue - <span class="bottom-line" style="width: 195px">{{ lc_data.mothertoungue }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Religion - <span class="bottom-line" style="width: 250px">{{ lc_data.religion }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Caste - <span class="bottom-line" style="width: 265px">{{ lc_data.caste }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Sub Caste - <span class="bottom-line" style="width: 230px">{{ lc_data.subcaste }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Birth Place/City  - <span class="bottom-line" style="width: 196px">{{ lc_data.birth_place }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Taluka - <span class="bottom-line" style="width: 258px">{{ lc_data.birth_taluka }}</span></v-col>
          <v-col class="pt-0" cols="4" sm="4" md="4">Dist - <span class="bottom-line" style="width: 275px">{{ lc_data.birth_district }}</span></v-col>
          <v-col class="pt-0" cols="5" sm="5" md="5">State - <span class="bottom-line" style="width: 354px">{{ lc_data.birth_state }}</span></v-col>
          <v-col class="pt-0" cols="7" sm="7" md="7">Country - <span class="bottom-line" style="width: 505px">{{ lc_data.birth_country }}</span></v-col>
          <v-col class="pt-0" cols="12" sm="12" md="12">Date of Birth as per Christian Era  - <span class="bottom-line" style="width: 760px">{{ lc_data.dob_fig }}</span></v-col>
          <v-col class="pt-0" cols="12" sm="12" md="12">Date of Birth in Words  - <span class="bottom-line" style="width: 838px">{{ lc_data.dob_words }}</span></v-col>
          <v-col class="pt-0" cols="12" sm="12" md="12">Name of the Previous School & Std  - <span class="bottom-line" style="width: 742px">{{ lc_data.last_school }} Std. {{ lc_data.previousschoolpassingstandard }}</span></v-col>
          <v-col class="pt-0" cols="6" sm="6" md="6">Date of Admission  - <span class="bottom-line" style="width: 347px">{{ lc_data.doa }}</span></v-col>
          <v-col class="pt-0" cols="6" sm="6" md="6">Std. - <span class="bottom-line" style="width: 447px">{{ lc_data.standard }}</span></v-col>
          <v-col class="pt-0" cols="6" sm="6" md="6">Progress in Study  - <span class="bottom-line" style="width: 352px">{{ lc_data.progress }}</span></v-col>
          <v-col class="pt-0" cols="6" sm="6" md="6">Behaviour - <span class="bottom-line" style="width: 405px">{{ lc_data.conduct }}</span></v-col>
          <v-col class="pt-0" cols="12" sm="12" md="12">Date of Leaving School - <span class="bottom-line" style="width: 828px">{{ lc_data.last_date_of_school }}</span></v-col>
          <v-col class="pt-0" cols="12" sm="12" md="12">Std. in which studying & since when (Both in words & figures) - <span class="bottom-line" style="width: 562px">{{ lc_data.std_in_words }} since {{ lc_data.standard_since_when }}</span></v-col>
          <v-col class="pt-0" cols="12" sm="12" md="12">Reason of Leaving School - <span class="bottom-line" style="width: 809px">{{ lc_data.reason }}</span></v-col>
          <v-col class="pt-0" cols="12" sm="12" md="12">Remark - <span class="bottom-line" style="width: 937px">{{ lc_data.remark }}</span></v-col>
        </div>
        <br>
        <div style="color: navy; padding-bottom: 15px;">Certified that above mentioned information is true according to the school General Register No.________</div>
        <span style="color: navy;">Date : {{ lc_data.date_of_issue }}</span>
        <v-row class="ssc-last-row">          
          <v-col cols="4" sm="4" md="4" align="center"><b>CLASS TEACHER</b></v-col>
          <v-col cols="4" sm="4" md="4" align="center"><b>CLERK</b></v-col>
          <v-col cols="4" sm="4" md="4" align="center"><b>PRINCIPAL</b></v-col>          
        </v-row>        
       <center><p style="color: white; background-color: red; font-size: large;">Note:- If any Unauthorized Change Made in the Certificate, would be liable for legal action.</p></center>
      </div> 
    </div>
    <div class="no-display" v-if="lc_data != null">
      <div style="text-align: center">
        ----------------------------------Modify------------------------------------
      </div>
      <br />

      <v-row justify="center" class="mt-3">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Progress"
            v-model.trim="lc_data.progress"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Conduct"
            v-model.trim="lc_data.conduct"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Remark"
            v-model.trim="lc_data.remark"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Reason"
            v-model.trim="lc_data.reason"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="mb-2 button" color="warning" @click="savegenLC()" small
          >Save</v-btn
        >
      </v-row>
      <hr />
      <v-row class="no-display">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Birth in words"
            v-model.trim="lc_data.dob_words"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Last School"
            v-model.trim="lc_data.last_school"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Standard"
            v-model.trim="lc_data.standard"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Since when..."
            v-model.trim="lc_data.standard_since_when"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Caste"
            v-model.trim="lc_data.caste"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Religion"
            v-model.trim="lc_data.religion"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-btn @click="proceed" class="info">Proceed to print</v-btn>
      </v-row>
    </div> 
    </div>   
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
      data() {
    return {
      mark_inactive: false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      board_toggle: "SSC",
      //////date
      last_date_of_school: "",
      gen_date: "",
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date_of_application: new Date().toISOString().substr(0, 10),
      date_of_issue: new Date().toISOString().substr(0, 10),
      application_date: "",
      issue_date: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      org_basic_data: null,
      condition: false,
      org_id: null,
    };
  },
  watch: {
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date2(val) {
      this.gen_date = this.formatDate(this.date2);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
      this.lc_data.date_of_application = this.application_date;
    },
    date_of_issue(val) {
      this.issue_date = this.formatDate(this.date_of_issue);
      this.lc_data.date_of_issue = this.issue_date;
    },
  },
  methods: {
    setToText() {
      this.lc_data.date_of_application = this.application_date;
    },
    setToText2() {
      this.lc_data.date_of_issue = this.issue_date;
    },
    savegenLC() {
      const formData = {
        lid: this.registration_no.lid,
        progress: this.lc_data.progress,
        conduct: this.lc_data.conduct,
        remark: this.lc_data.remark,
        reason: this.lc_data.reason,
        gen_date: this.date_of_generation,
      };
      this.overlay = true;
      axios
        .post("/certificate/genLC", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            this.lc_data.last_school = this.org_basic_data.school_name;
            this.showSnackbar("green", "Success..!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    proceed() {
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem(
        "org_basic_data",
        JSON.stringify(this.org_basic_data)
      );
      let routeData = this.$router.resolve({ name: "ssjc-lc-print" });
      window.open(routeData.href, "_blank");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_remark[0];
            this.condition = res.data.condition;
            if (!this.condition)
              this.showSnackbar("red", res.data.condition_msg);
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To generate LC as fees is pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        this.last_date_of_school != "" &&
        this.gen_date != "" &&
        this.remark != null &&
        this.reason != null &&
        this.application_date != "" &&
        this.issue_date != ""
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          last_date_of_school: this.last_date_of_school,
          gen_date: this.gen_date,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          mark_inactive: this.mark_inactive,
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              this.lc_data.last_school = this.org_basic_data.school_name;
              // if (this.lc_data.caste == null) {
              //   alert("Caste is not enter ..");
              // }
              // this.showSnackbar("green", "User data fetched!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            this.lc_data.last_school = this.org_basic_data.school_name;
            this.date_of_application = this.formatDate(
              this.lc_data.date_of_application
            );
            this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);

            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    localStorage.setItem("lc_data", null);
    localStorage.setItem("org_basic_data", null);
    localStorage.setItem("last_date_of_school", "");
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.gen_date = this.formatDate(this.date2);
    this.application_date = this.formatDate(this.date_of_application);
    this.issue_date = this.formatDate(this.date_of_issue);
    this.org_id = localStorage.getItem("EPS-org-id")
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}
.mytable1 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
.expapanel {
  width: 93%;
  margin-left: 3%;
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3792c7,
    #60e3eb,
    #a0dfe3
  ); /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}
.fees span {
  font-size: 23px;
  font-weight: 600;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: rgb(248, 248, 241);
  background-position: center;
}
.gradient-heading {
    background-image: linear-gradient(to bottom, #EC407A, #4A148C);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-family: "Times New Roman", Times, serif;
    margin-bottom: 15px;
}
.main{
  padding: 20px;
}
.bottom-line{
  border-bottom: 1px solid;
  display: inline-block;
  padding-bottom: 1px;
}
.header {
  margin: 6px;
}
.tdata2 {
  font-weight: bolder;
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(235, 61, 61);
}
.ssc-last-row{
  color: #1B5E20; 
  margin-top: 70px; 
  margin-bottom: 10px;
}
/* lc data css end */

/* print lc css */
@media print {
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
  }
  #document1 {
    position: absolute;
    margin-top: -63px;
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .text-color{
    padding: 20px !important;
    margin-left: -15px;
  }
  .main{
    width: 100%;
    padding: 10px;
    margin-left: -13px;
    margin-right: -10px !important;
    /* margin-top: -10px !important; */
  }
  .ssc-matter{
    line-height: 200% !important;
  }
  .ssc-line-height{
    line-height: 160%;
  }
  .ssc-last-row{
    margin-top: 100px !important;
  }
  .gradient-heading{
    font-size: 40px;
  }
  @page {
    size: A4;
    margin: none;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */
span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}
.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

h3.stretch2 {
  display: inline-block;
  -webkit-transform: scale(2, 1); /* Safari and Chrome */
  -moz-transform: scale(1.5, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
}
</style>